import React,{ useState,useEffect } from 'react';
import axios from "axios";
import store from '../store';

const chatApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/chat/`
})
const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/user/UserAPI/`
})

const MessageBox = () => {
    useEffect(() => {
        getContacts(store.getState().auth.user.id);
      },[]);
    const[message,setMessage]=useState('');
    const[selected,setSelect]=useState(null);
    const[messages,setMessages]=useState([]);
    const[contacts,setContacts]=useState([]);
    const[Rcontact,setRContact]=useState([]);
    const[id,setId]=useState(null);
    const me = store.getState().auth.user.id;
    const addMessage =async () => {
        let data = new FormData();
        data.append('message',message );
        data.append('sender',me);
        data.append('receiver',selected);
        try {
            await chatApi.post('MessageCreate/',data);


            let data1 = new FormData();
            data1.append('last_message',new Date().toJSON());
            await chatApi.put(`UpdateContact/${id}/`,data1);
            let data2 = new FormData();
            data2.append('last_message',new Date().toJSON());
            data2.append('unread',Rcontact[0].unread+1);
            await chatApi.put(`UpdateContact/${Rcontact[0].id}/`,data2);

            
        }
        catch{
            alert("Can't send message!");
        }
        setMessage('');
        getMessages(selected,id);
    }
    const getMessages = async(user,id) => {
        let data = await chatApi.get(`MessageRead/${user}/${me}/`).then(({data})=>data);
        data.map(a=>
            readmsg(a)
            )
        setMessages(data);
        setSelect(user) ;
        setId(id);
        let data1 = await chatApi.get(`Rcontact/${user}/${me}/`).then(({data})=>data);
        setRContact(data1)
        
        let data2 = await chatApi.get(`Rcontact/${me}/${user}/`).then(({data})=>data);

        let data3 = new FormData();
        data3.append('unread',0);
        await chatApi.put(`UpdateContact/${data2[0].id}/`,data3);
        
    }
    const readmsg = async (a) => {
        if(a.receiver === me && a.is_read === false){
            let data1 = new FormData()
            data1.append('is_read',true)
            await chatApi.put(`updateMsg/${a.id}/`,data1)
        }
        
    }
    const getContacts = async(user) => {
        let data = await chatApi.get(`ContactList/${user}/`).then(({data})=>data);
        //const contacts = data.map(({Contact_id}) => Contact_id);
        //setContacts(contacts);
        data.map(a =>
            getReviewGiverName(a,data)
        ) 
    }
    const getReviewGiverName= async (a,data) => {
        let data1 = await api.get(`/${a.Contact_id}/`).then(({data})=>data);
        a.name=data1[0].first_name + ' ' + data1[0].last_name
        setContacts(data);
    }
    return (
        <div className="modal-dialog modal-lg" >
                <div className="modal-content">
                <div className="row mt-3" >
                    <h5 className="modal-title col col-lg-4 ps-4" ><b>Messages</b></h5>
                    <h5 className='col col-lg-6 ps-5'>  </h5>
                    <div className='col ps-5'>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                </div>
                {localStorage.access ?<>
                <hr style={{padding: '0px',marginTop: '5px', margin:'0px' }}/>
                <div className="modal-body row" style={{height:340}}>
                    <div className='col col-lg-4' style={{borderRight: '3px solid gray'}}>
                        {contacts.map(a=>
                            <><button className='btn' onClick={()=>{getMessages(a.Contact_id,a.id); a.unread=0}} >{a.name}  {a.unread !== 0 ? <span style={{backgroundColor:'#FFC312',borderRadius:10,padding:1,fontSize:'14px',textAlign:'center'}}>{a.unread}</span> : null}</button><hr/></>
                        )}
                    </div>
                    <div className='col' >
                        <div style={{height:'260px',overflowY: 'auto',marginBottom:'5px'}}>
                            {!messages.length ? 
                
                                <p style={{ textAlign:'center'}}>Start A conversation to see Messages</p>
                                
                            : 
                            <div>
                                {messages.map((val) => {
                                    return(
                                        <>
                                        {val.sender === store.getState().auth.user.id ?
                                        <div key={val.id} style={{display:'flex', justifyContent:'flex-end'}}>
                                            <p className='px-3 py-1' style={{display:'inline-block',backgroundColor:'lightblue',borderRadius:7,maxWidth:'70%'}}>{val.message}</p><br/>
                                        </div>
                                        :
                                        <div key={val.id}>
                                            <p className='px-3 py-1' style={{display:'inline-block',backgroundColor:'lightgray',borderRadius:7,maxWidth:'70%'}}>{val.message}</p><br/>
                                        </div>
                                        }
                                        </>
                                    );
                                })}
                            </div>
                            }
                        </div>
                        {selected !== null ?
                        <div className='row'>
                            <div className='col col-lg-10'><textarea className="form-control" placeholder='type a message' onChange={(e)=>setMessage(e.target.value)} value={message} style={{width:'100%'}} /></div>
                            <button onClick={()=>addMessage()} title='send Message' style={{border: 'none',backgroundColor: 'transparent'}} className='col col-lg-1 ' > <i className='fa fa-play-circle' style={{fontSize:'36px', color:'#FFC312'}}></i> </button>
                        </div>
                        : null}
                    </div>
                </div></>
                :
                <div style={{height:350}}>
                    <h1>Login Please</h1>
                </div>
            }
                </div>
        </div>
    );
};



export default MessageBox;
